<template>
  <div>
    <div class="content-header case-search-header">
      <div class="content-header-left">
        <div class="filters-row">
          <div class="con-select d-flex">
            <div class="selection_search  ml-0"> <!--casetype-->
              <div class="search">
                <div class="vs-component vs-con-input-label vs-input is-label-placeholder vs-input-primary">
                  <div class="vs-con-input">
                    <vs-input :key="'searchtxt'" icon-pack="feather" icon="icon-search" :placeholder="'Case no/Employee Name/ID'"
                      class="is-label-placeholder" v-model.lazy="searchtxt" />
                  </div>
                </div>
              </div>
            </div>
            <vs-checkbox v-if="routeName != 'Purged PAF forms'" id="purgedCases" @input="changeActiveType(purgedCases)" class="ml-2 xs-hidden" name="purgedCases"
              v-model="purgedCases">Purged
            </vs-checkbox>
          </div>

        </div>
      </div>
      
      <div class="content-header-right">
        <!--filter dropdown-->
        <vs-inv-dropdown >
            <div class="filters-content">
            <div class="filters-form-fileds noscroll">
              <div class="form-container ">
                <div class="vx-row">
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <!-- :maxDate="new Date()" -->
                    <label class="typo__label">LCA Expiration Date Range</label>
                    <date-range-picker :autoApply="autoApply" :ranges="false" :opens="'left'"
                      v-model="lcaExpirationDateRange"></date-range-picker>
                  </div>
                  <!-- <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">LCA Withdrawal Date Range</label>
                    <date-range-picker  :autoApply="autoApply" :ranges="false" :opens="'left'"
                      v-model="lcaWithdrawalDateRange"></date-range-picker>
                  </div> -->
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <!-- :maxDate="new Date()" -->
                    <label class="typo__label">Termination Date Range</label>
                    <date-range-picker  :autoApply="autoApply" :ranges="false" :opens="'left'"
                      v-model="terminatedOnRange"></date-range-picker>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <!-- :maxDate="new Date()" -->
                    <label class="typo__label">Retention Date Range</label>
                    <date-range-picker  :autoApply="autoApply" :ranges="false" :opens="'left'"
                      v-model="retentionDateRange"></date-range-picker>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select" v-if= "routeName != 'Purged PAF forms'">
                    <label class="typo__label">Status</label>
                    <multiselect
                      v-model="selectedStatus"
                      :options="statusOptions"
                      :multiple="false" :hideSelected="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Status"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      <!-- <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span
                          class="multiselect__single"
                          v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} options selected</span>
                      </template> -->
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Status Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons"></div>
              <div class="right-buttons">
                <vs-button color="success" class="save" type="filled" v-on:click="set_filter()">Apply</vs-button>
                <vs-button color="dark" class="cancel" type="filled" v-on:click="clear_filter($event)">Clear</vs-button>
              </div>
            </div>
          </div>
          <!-- </vs-dropdown-menu> -->
        <!-- </vs-dropdown> -->
      </vs-inv-dropdown>
        <div class="Generate_buttons" @click="getExportList()">
          <button class="copy_link" v-bind:disabled="exportList">
            <img src="@/assets/images/main/share.png" />
            <small>Export</small>
          </button>
        </div>
        <!-- v-if="checkSelection" -->
        <div class="Generate_buttons mr-3" @click="getPAFDownloads()">
          <button class="copy_link" v-bind:disabled="downloadList">
            <img src="@/assets/images/main/download.svg" />
            <small>Download</small>
          </button>
        </div>
      </div>
    </div>
    <NoDataFound ref="NoDataFoundRef" :loading="isListloading" v-if="pafList.length == 0" content=""
      :heading="callFromSearch ? 'No Results Found' : 'No Cases Found'" type='petitions' />
    <div class="accordian-table paf_table" v-if="pafList.length > 0">

      <vs-table :data="pafList" :no-data-text="'No data found...!'">
        <template slot="thead">
          <vs-th>
            <div class="d-flex">
              <vs-checkbox
                @change="selectAllforArchive()" :name="'selecteAll'" v-model="selectedAllForArchive" class="">
              </vs-checkbox>
              <a @click="sortMe('caseNo')"
                v-bind:class="{ 'sort_ascending': sortKeys['caseNo'] == 1, 'sort_descending': sortKeys['caseNo'] != 1 }">Case
                No</a> 
            </div>
          </vs-th>
        
          <vs-th>
            <div>
              <!-- <a @click="sortMe('employeeName')"
                v-bind:class="{ 'sort_ascending': sortKeys['employeeName'] == 1, 
                'sort_descending': sortKeys['employeeName'] != 1 }"> -->
                Employee Name
            <!-- </a> -->
            </div>
          </vs-th>

          <vs-th>
            <div>
              <!-- <a @click="sortMe('employeeId')"
                v-bind:class="{ 'sort_ascending': sortKeys['employeeId'] == 1, 
                'sort_descending': sortKeys['employeeId'] != 1 }"> -->
                Employee ID
            <!-- </a> -->
            </div>
          </vs-th>

          <vs-th>
            <div>
              <a @click="sortMe('expirationDate')"
                v-bind:class="{ 'sort_ascending': sortKeys['expirationDate'] == 1, 
                'sort_descending': sortKeys['expirationDate'] != 1 }">
                LCA Expiration Date </a>
            </div>
          </vs-th>

          <!-- <vs-th>
            <div>
              <a @click="sortMe('withdrawalDate')"
                v-bind:class="{ 'sort_ascending': sortKeys['withdrawalDate'] == 1, 
                'sort_descending': sortKeys['withdrawalDate'] != 1 }">
                LCA Withdrawal Date</a>
            </div>
          </vs-th> -->

          <vs-th>
            <div>
              <a @click="sortMe('terminatedOn')"
                v-bind:class="{ 'sort_ascending': sortKeys['terminatedOn'] == 1, 
                'sort_descending': sortKeys['terminatedOn'] != 1 }">
                Date of Termination</a>
            </div>
          </vs-th>

          <vs-th>
            <div>
              <a @click="sortMe('retentionDate')"
                v-bind:class="{ 'sort_ascending': sortKeys['retentionDate'] == 1, 
                'sort_descending': sortKeys['retentionDate'] != 1 }">
                PAF Retention End Date</a>
            </div>
          </vs-th>

          <vs-th>
            <div>
              <!-- <a @click="sortMe('statusName')"
                v-bind:class="{ 'sort_ascending': sortKeys['statusName'] == 1, 'sort_descending': sortKeys['statusName'] != 1 }">Status</a> -->
                Status
            </div>
          </vs-th>
          
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="petition" :key="index" v-for="(petition, index) in data">

            <!-- Checkbox + customId -->
            <vs-td>
              <vs-checkbox
                @change="selectForArchive(petition)"
                :name="'selected_' + petition.index"
                v-model="petition.selectedForArchive"
              ></vs-checkbox>
              <!-- <span class="cursor-pointer" @click="petitionlink(petition)"> -->
                <span>
                {{ checkProperty(petition, 'customId') ? checkProperty(petition, 'customId') : '-' }}
              </span>
            </vs-td>

            <!-- Employee Name -->
            <vs-td>
              <template v-if="checkProperty(petition, 'employeeName')">
                {{ checkProperty(petition, 'employeeName') | CapSubString }}
              </template>
              <template v-else>-</template>
            </vs-td>

            <!-- Employee ID -->
            <vs-td>
              {{ checkProperty(petition, 'employeeId') ? checkProperty(petition, 'employeeId') : '-' }}
            </vs-td>

            <!-- LCA Expiry Date -->
            <vs-td>
              <template v-if="checkProperty(petition, 'lcaDetails') && checkProperty(petition, 'lcaDetails', 'lcaExpiryDate')">
                {{ checkProperty(petition, 'lcaDetails', 'lcaExpiryDate') | formatDateUtc }}
              </template>
              <template v-else>-</template>
            </vs-td>

            <!-- LCA Withdrawal Date -->
            <!-- <vs-td>
              <template v-if="checkProperty(petition, 'lcaDetails') && checkProperty(petition, 'lcaDetails', 'lcaWithdrawalDate')">
                {{ checkProperty(petition, 'lcaDetails', 'lcaWithdrawalDate') | formatDateUtc }}
              </template>
              <template v-else>-</template>
            </vs-td> -->

            <!-- Terminated On -->
            <vs-td>
              <template v-if="checkProperty(petition, 'terminatedOn')">
                {{ checkProperty(petition, 'terminatedOn') | formatDateUtc }}
              </template>
              <template v-else>-</template>
            </vs-td>

            <!-- Retention Date -->
            <vs-td>
              <template v-if="checkProperty(petition, 'retentionDate')">
                {{ checkProperty(petition, 'retentionDate') | formatDateUtc }}
              </template>
              <template v-else>-</template>
            </vs-td>

            <!-- Status -->
            <vs-td>
              <span class="statusspan cursor-pointer"
                :class="{
                  'status_created': checkProperty(petition, 'statusName') == 'Active',
                  'status_denied': checkProperty(petition, 'statusName') == 'Purged'
                }">
                {{ checkProperty(petition, 'statusName') ? checkProperty(petition, 'statusName') : '-' }}
                </span>
            </vs-td>

          </vs-tr>
        </template>

      </vs-table>
      
      <div class="table_footer">
        <div class="vx-col  con-select pages_select" v-if="pafList.length > 0">
          <label class="typo__label">Per Page</label>
          <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false" :allow-empty="false"
            :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
            :preselect-first="true">

          </multiselect>
          <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
        </div>
        <paginate v-if="pafList.length > 0" v-model="page" :page-count="totalpages" :page-range="3"
          :margin-pages="2" :click-handler="pageNate"
          prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
          next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
          :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'">
        </paginate>
      </div>
    </div>
    
  </div>
</template>
<script>
import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
import Paginate from "vuejs-paginate";
import moment from 'moment'
import _ from "lodash";
import Vue from 'vue'
import NoDataFound from "@/views/common/noData.vue";
import Multiselect from "vue-multiselect-inv";
import DateRangePicker from "vue2-daterange-picker";
import Datepicker from "vuejs-datepicker-inv";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  watch: {
    searchtxt: function (value) {
      // let text = value.trim();

      // if (text.length > 3 || text == '') {
      //   this.getPAFList(true, false);
      // }
      this.searchMe();
    },
  },
  data: function () {
    return {
      routeName : '',
      selectedAllForArchive:false,
      isPurged : false,
      autoApply: "",
      debounce:null,
      exportList: false,
      downloadList: false,
    purgedCases: false,
      exportData: {},
      selectedStatus: null,
      statusOptions: [
        {id:1,name:'Active'},
        {id:2,name:'Purged'}
      ],
      pafList: [],
      selectedPAFList:[],
      selectedForArchiveList:[],
      selectedCaseItems:[],
      selectedIds:[],
      sortKeys: {},
      sortKey: {},
      page: 1,
      perpage: 25,
      totalpages: 0,
      totalCount:0,
      perPeges: [10, 25, 50, 75, 100, 500],
      callFromSearch: false,
      isListloading: false,
      searchtxt: '',
      encodedString: '',
      // hiredOnRange: null,
      lcaExpirationDateRange: ["",""],
      lcaWithdrawalDateRange: ["",""],
      // terminatedOnRange: null,
      terminatedOnRange: ["",""],
      retentionDateRange: ["",""],
    }
  },
  components: {
    vsInvDropdown,
    Multiselect,
    Paginate,
    NoDataFound,
    Datepicker,
    DateRangePicker,
    moment
  },
  methods: {
    selectAllforArchive() {
      this.selectedForArchiveList = [];
      this.selectedPAFList = [];
      _.forEach(this.pafList, (item) => {
        item.selectedForArchive = false;
        if (this.selectedAllForArchive) {
          item.selectedForArchive = true;
          this.selectedForArchiveList.push(item._id)
          this.selectedCaseItems.push(item);
          this.selectedPAFList.push(item);

        }

      })
      this.selectedIds = [...this.selectedForArchiveList];

      if (this.pafList.length > 0 && this.pafList.length != this.selectedForArchiveList.length) {
        this.selectedAllForArchive = false;
      }



    },
    selectForArchive(caseItem) {
          if (this.checkProperty(caseItem, 'selectedForArchive')) {
            if (this.selectedForArchiveList.indexOf(caseItem['_id']) <= -1) {
              this.selectedForArchiveList.push(caseItem['_id'])
              if (!this.selectedPAFList.includes(caseItem)) {
                this.selectedPAFList.push(caseItem);
              }
              if (!this.selectedCaseItems.includes(caseItem)) {
                this.selectedCaseItems.push(caseItem);
              }
            }

          } else {
            this.selectedForArchiveList = _.filter(this.selectedForArchiveList, (item) => {
              return item != caseItem['_id']
            })
            this.selectedCaseItems = _.filter(this.selectedCaseItems, (item) => {
              return item != caseItem
            })
            this.selectedPAFList = _.filter(this.selectedPAFList, (item) => {
              return item !== caseItem;
            })
          }
        this.selectedAllForArchive = false
        if (this.pafList.length == this.selectedForArchiveList.length && this.selectedForArchiveList.length > 0) {
          this.selectedAllForArchive = true
        }
        this.selectedIds = [...this.selectedForArchiveList];

    },
    changeActiveType(item){
      if(item){
        this.isPurged = true;
        this.selectedStatus = {id:2,name:'Purged'};
      }else{
        this.isPurged = false;
        this.selectedStatus = null;
      }
      this.getPAFList();
    },
    searchMe(){
        let self =this;
      this.page = 1;
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        self.getPAFList(true, false);
      }, 900)
    },
    getPAFList(callFromSearch = false, callFromFilter = false) {
      this.exportData = {};
      this.callFromSearch = callFromSearch
      if (this.callFromSearch) {
        this.pafList = []
      }
      //'623b3c3c75d58329b830cdcd','625e6857cadbc43c50c92ee7','628f6b6b096c8624d886648b'
      // "lcaExpirationDateRange": (this.lcaExpirationDateRange[0] !== "" || this.lcaExpirationDateRange[1] !== "") ? this.lcaExpirationDateRange : null,
      //                 "lcaWithdrawalDateRange": (this.lcaWithdrawalDateRange[0] !== "" || this.lcaWithdrawalDateRange[1] !== "") ? this.lcaWithdrawalDateRange : null,
      //                 "terminateDateRange": (this.terminatedOnRange[0] !== "" || this.terminatedOnRange[1] !== "") ? this.terminatedOnRange : null,
      //                 "retentionDateRange": (this.retentionDateRange[0] !== "" || this.retentionDateRange[1] !== "") ? this.retentionDateRange : null,
      let Payload = {
        "matcher": {
                      "searchString": this.searchtxt,
                      
                  },
        page: this.page,
        perpage: this.perpage,
        sorting: this.sortKey,
        today: moment().format('YYYY-MM-DD'),
      }
      if (this.lcaExpirationDateRange.startDate && this.lcaExpirationDateRange.endDate) {
        Payload["matcher"]["lcaExpirationDateRange"] = [
          moment(this.lcaExpirationDateRange.startDate).format("YYYY-MM-DD"),
          moment(this.lcaExpirationDateRange.endDate).format("YYYY-MM-DD")
        ];
      }
      if (this.lcaWithdrawalDateRange.startDate && this.lcaWithdrawalDateRange.endDate) {
        Payload["matcher"]["lcaWithdrawalDateRange"] = [
          moment(this.lcaWithdrawalDateRange.startDate).format("YYYY-MM-DD"),
          moment(this.lcaWithdrawalDateRange.endDate).format("YYYY-MM-DD")
        ];
      }
      if (this.terminatedOnRange.startDate && this.terminatedOnRange.endDate) {
        Payload["matcher"]["terminateDateRange"] = [
          moment(this.terminatedOnRange.startDate).format("YYYY-MM-DD"),
          moment(this.terminatedOnRange.endDate).format("YYYY-MM-DD")
        ];
      }
      if (this.retentionDateRange.startDate && this.retentionDateRange.endDate) {
        Payload["matcher"]["retentionDateRange"] = [
          moment(this.retentionDateRange.startDate).format("YYYY-MM-DD"),
          moment(this.retentionDateRange.endDate).format("YYYY-MM-DD")
        ];
      }
      if (this.selectedStatus && this.selectedStatus.hasOwnProperty('name')) {
        Payload['matcher']['status'] = this.selectedStatus.name
      };
      if(this.isPurged && this.$router.currentRoute.name != 'Purged PAF forms'){
        Payload['matcher']['purged']= this.isPurged
      }
      if(this.$router.currentRoute.name == 'Purged PAF forms'){
        this.isPurged = true;
        Payload['matcher']['purged']= this.isPurged;
        Payload['matcher']['status']= 'Purged';
      }
      this.exportData = Payload['matcher'];
      this.isListloading = true;
      this.updateLoading(true);
      let tempObj={
          selectedStatus:this.selectedStatus,
          searchtxt:this.searchtxt,
          page:this.page,
          perpage:this.perpage,
          sortKey:this.sortKey
      };
      this.$store.dispatch("commonAction", { "data": Payload, "path": "/reports/purged-paf" }).then((response) => {
        this.setQueryString(tempObj)
        this.isListloading = false;
        this.updateLoading(false);
        this.pafList = response.list;
        this.totalCount = this.checkProperty(response, 'totalCount')
        this.totalpages = Math.ceil(response.totalCount / this.perpage)
        setTimeout(() => {
          this.updateLoading(false);
        }, 10);
      })
        .catch((err) => {
          this.isListloading = false;
          this.updateLoading(false);
        })
    },
    setQueryString(obj){
    const string = JSON.stringify(obj) // convert Object to a String
    this.encodedString = btoa(string) // Base64 encode the String
    this.$route['query']['filter'] = this.encodedString;
    },
    getExportList() {
      let Payload = {
        matcher: {},
        selectedIds: this.selectedIds,
        reportType: "PAF Retention Period Reports",
        page: this.page,
        perpage: this.perpage,
        sorting: this.sortKey,
        today: moment().format('YYYY-MM-DD'),
      };
      Payload['matcher'] = this.exportData;
      this.exportList = true;
      this.$store.dispatch("commonAction", { "data": Payload, "path": "/reports/export-paf" }).then((response) => {
        this.exportList = false;
        if (this.checkProperty(response, 'path')) {
          window.open(this.$globalgonfig._APIURL + "/common/viewfile?filename=PAF_Retention_Period_Report.xlsx&path=" + this.checkProperty(response, 'path'), "_blank");
        }
      }).catch((err) => {
        this.exportList = false;
      })
    },
    getPAFDownloads() {
      this.downloadList = true;
      let Payload = {
        matcher: {
            
        },
        selectedIds: this.selectedIds,
        today: moment().format('YYYY-MM-DD'),
      };
      if(this.checkProperty(this.selectedIds, 'length') == 0 ){
        this.downloadList = false;
        this.showToster({ message: "Select at least one case to proceed with the download", isError: true });
      }
      this.$store.dispatch("commonAction", { "data": Payload, "path": "/reports/download-mul-pafdocs" }).then((response) => {
        this.downloadList = false;
        if (this.checkProperty(response, 'path')) {
          window.open(this.$globalgonfig._APIURL + "/common/viewfile?filename=PAF_zip.zip&path=" + this.checkProperty(response, 'path'), "_blank");
        }
      }).catch((err) => {
        this.downloadList = false;
      })
    },
    pageNate(pageNum) {

      this.page = pageNum;
      this.getPAFList();
    },
    changeperPage() {
      this.page = 1;
      localStorage.setItem('petitions_perpage', this.perpage);
      this.getPAFList(true);
    },
    sortMe(sort_key = '') {
      if (sort_key != '') {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1
        this.sortKey = {};
        this.sortKey = { "path": sort_key, "order": this.sortKeys[sort_key] }
        localStorage.setItem('petitions_sort_key', sort_key);
        localStorage.setItem('petitions_sort_value', this.sortKey[sort_key]);
        this.getPAFList();
      }
    },
    set_filter: function () {
      if(this.selectedStatus){
        if(this.selectedStatus.name == 'Active'){
          this.purgedCases = false;
          this.isPurged = false;
        }else{
          this.purgedCases = true;
          this.isPurged = true;
        }
      }
      this.page =1;
      this.getPAFList();
      document.body.classList.remove('scroll-hidden');
    },
    clear_filter: function () {
      this.searchtxt = '';
      this.lcaExpirationDateRange.startDate = "";
      this.lcaExpirationDateRange.endDate = "";
      this.lcaWithdrawalDateRange.startDate = "";
      this.lcaWithdrawalDateRange.endDate = "";
      this.terminatedOnRange.startDate = "";
      this.terminatedOnRange.endDate = "";
      this.retentionDateRange.startDate = "";
      this.retentionDateRange.endDate = "";
      if(this.selectedStatus){
        this.selectedStatus = null;
        this.purgedCases = false;
        this.isPurged = false;
      }
      this.getPAFList();
      document.body.classList.remove('scroll-hidden');
    },
    // petitionlink(tr) {
    //   let routedId = this.checkProperty(tr, '_id')
    //   this.$router.push({ path: `/paf-details/${routedId}`, query: { 'filter': this.encodedString } })   
    // },
  },
  mounted() {
    this.routeName = this.$router.currentRoute.name;
    this.sortKeys = {
      "caseNo": 1,
      "statusName": 1,
      "createdOn": 1,
      "updatedOn": -1,
      "employeeName": 1,
      "employeeId":1,
      "withdrawalDate":1,
      "retentionDate":1,
      "expirationDate":1,
      "terminatedOn":1,
    },
      this.sortKey = { "path": 'updatedOn', "order": -1 };
    if (localStorage.getItem('petitions_sort_key') && localStorage.getItem('petitions_sort_value') && localStorage.getItem('petitions_sort_value') >= -1) {
      this.sortKey = {};
      this.sortKey = { "path": localStorage.getItem('petitions_sort_key'), "order": parseInt(localStorage.getItem('petitions_sort_value')) };
      this.sortKeys[localStorage.getItem('petitions_sort_key')] = parseInt(localStorage.getItem('petitions_sort_value'));
     
    }
    // if(this.$router.currentRoute.name == 'Purged PAF forms'){
    //     this.isPurged = true;
    // }
    this.getPAFList();
  },
  computed:{}
};
</script>
